import BaseCtrl from 'edge/platform/base/BaseCtrl';

const fn = (ModalService, $translate, $scope, $q, $stateParams, PolicyService) => {
    const ctrl = Object.create(BaseCtrl);
    ctrl.init = () => {
        initialiseScopeVariables();
        ctrl.getDocuments();
    };

    /* Private Functions*/
    function initialiseScopeVariables() {
        // Document metadata template for document upload
        $scope.documentMetaDataTemplate = {
            docUID: '001',
            documentType: 'letter_received',
            securityType: 'unrestricted',
            status: 'approved',
            policyNumber: $stateParams.policyNumber
        };

        $scope.policyNumber = $stateParams.policyNumber;
        $scope.documents = [];
        $translate('gateway.directives.gateway-documents.There are no documents associated with this policy').then((msg) => {
            $scope.noDocumentsMessage = msg;
        });
    }

    ctrl.getDocuments = () => {
        const documentsRequest = PolicyService.getDocumentsForPolicy($stateParams.policyNumber);
        $scope.documentsRequest = documentsRequest;

        $q.when(
            documentsRequest,
            (documents) => {
                $scope.documents = documents;
            },
            () => {
                const msg = $translate(
                    'gateway.views.policy-detail.documents.error',
                    {policyNumber: $stateParams.policyNumber}
                );
                ModalService.showError('gateway.views.modal.Error', msg);
            }
        );
    };

    return ctrl.create($scope);
};
fn.$inject = ['ModalService', '$translate', '$scope', '$q', '$stateParams', 'PolicyService'];

export default fn;